import styled from '@emotion/styled'

export const BankAccountContainerStyled = styled('section')({
  fontSize: '1.2rem',
  padding: '2rem',
})

export const BankNameStyled = styled('p')({
  fontSize: '2.2rem',
  margin: 0,
})

export const BankBranchStyled = styled('p')({
  fontSize: '1.6rem',
  margin: '0.5rem 0',
})
